<template>
  <section class="section-organization">
    <div class="section-title">
      <span class="dot-left">
        <i></i>
        <i></i>
        <i></i>
      </span>
      {{ $t("content.organization.title") }}
      <span class="dot-right">
        <i></i>
        <i></i>
        <i></i>
      </span>
    </div>

    <div class="content-outer">
      <!-- 主办方区域 -->
      <div class="host-block">
        <h3 class="block-title">{{ $t("content.organization.host") }}</h3>

        <div class="logo-wrap host-logo-wrap">
          <div class="logo-card">
            <img :src="require('@/assets/images/logo2.png')" alt="北京交通大学" />
          </div>
        </div>
      </div>

      <!-- 协办方区域 -->
      <div class="co-block">
        <h3 class="block-title">{{ $t("content.organization.co") }}</h3>
        <div class="logo-wrap co-logo-wrap">
          <div class="logo-card">
            <img :src="hostLogo" alt="主办方logo" />
          </div>

          <div class="logo-card">
            <img :src="require('@/assets/images/logo-3.png')" alt="西南交通大学" />
          </div>

          <div class="logo-card">
            <img :src="require('@/assets/images/logo-2.png')" alt="中国科学院力学研究所" />
          </div>

          <div class="logo-card">
            <img :src="require('@/assets/images/logo-5.png')" alt="中国科学院力学研究所" />
          </div>

        </div>
      </div>

      <!-- ========== 新增：承办方区域（纯文字，无 logo） ========== -->
      <div class="undertake-text-wrap">
        <h3 class="block-title">{{ $t("content.organization.undertake") }}</h3>
        <div
          v-for="(item, idx) in undertakeList"
          :key="idx"
          class="undertake-line"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus } from '@/utils/eventBus.js';

export default {
  data() {
    return {
      currentLocale: localStorage.getItem('locale') || 'zh-cn',
    };
  },
  computed: {
    isEn() {
      const locale = this.$i18n?.locale || this.currentLocale || 'zh-cn';
      return locale === 'en' || locale === 'en-US';
    },
    hostLogo() {
      return this.isEn
        ? require('@/assets/images/logo-1-en.png')
        : require('@/assets/images/logo-1-zh.png');
    },
    /**
     * 承办方文字列表，中英文自动切换
     */
    undertakeList() {
      if (this.isEn) {
        return [
          'Railway Industry Key Laboratory of Structural Reliability of high-speed EMUs',
          'Engineering Research Center of the Ministry of Education for Reliability and Detection Technology of Rail Transit Equipment',
        ];
      }
      return [
        '高速动车组结构可靠性铁路行业重点实验室',
        '轨道交通装备可靠性与检测技术教育部工程研究中心',
      ];
    },
  },
  created() {
    eventBus.$on('language-changed', this.handleLanguageChange);

    if (this.$i18n && this.$i18n.on) {
      this.$i18n.on('languageChanged', this.handleLanguageChange);
    }
  },
  beforeDestroy() {
    eventBus.$off('language-changed', this.handleLanguageChange);
    if (this.$i18n && this.$i18n.off) {
      this.$i18n.off('languageChanged', this.handleLanguageChange);
    }
  },
  methods: {
    handleLanguageChange(lang) {
      this.currentLocale = lang || 'zh-cn';
      console.log('当前语言:', this.currentLocale);
    },
  },
};
</script>

<style scoped>
.section-organization {
  padding: 40px;
  width: 100%;
}

/* 全局统一标题样式 */
.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 24px;
  font-weight: 500;
  color: #0f3494;
  margin: 0 0 40px;
}
.dot-left, .dot-right {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dot-left i, .dot-right i {
  background-color: #0f3494;
  border-radius: 2px;
}
.dot-left i:nth-child(1) { width: 5px; height: 5px; }
.dot-left i:nth-child(2) { width: 8px; height: 8px; }
.dot-left i:nth-child(3) { width: 12px; height: 12px; }
.dot-right i:nth-child(1) { width: 12px; height: 12px; }
.dot-right i:nth-child(2) { width: 8px; height: 8px; }
.dot-right i:nth-child(3) { width: 5px; height: 5px; }

/* 统一最大宽度容器，和上方板块左右对齐 */
.content-outer {
  max-width: 1300px;
  margin: 0 auto;
}

/* =======改动：block-title居中======= */
.block-title {
  font-size: 20px;
  color: #0f3494;
  font-weight: 400;
  margin: 0 0 20px 0;
  text-align: center;
}

.host-block {
  margin-bottom: 40px;
}

/* 主办方单独布局：单个logo居中 */
.host-logo-wrap {
  display: flex;
  justify-content: center;
}
.host-logo-wrap .logo-card {
  max-width: 240px;
  width: 100%;
}

/* ==========【重点修改协办方样式】========== */
.co-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}

/* 卡片核心样式 */
.logo-card {
  width: 100%;
  max-width: 220px;
  height: 90px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 6px;
}
.logo-card img {
  max-width: 95%;
  max-height: 95%;
  width: auto;
  height: auto;
  display: block;
}

.co-block {
  margin-bottom: 40px;
}

.undertake-text-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.undertake-line {
  position: relative;
  padding-left: 18px;
  max-width: 900px;
  font-size: 16px;
  line-height: 1.7;
  color: #1a3a6b;
  text-align: left;
}

.undertake-line::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 70%;
  background: linear-gradient(180deg, #2978dd, #7aaef0);
  border-radius: 2px;
}

/* 平板适配 */
@media screen and (max-width: 1200px) {
  .content-outer {
    max-width: 96%;
  }
  .block-title {
    font-size: 20px;
  }
  .logo-card {
    height: 90px;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .section-organization {
    padding: 30px 16px 35px;
  }
  .section-title {
    font-size: 20px;
    gap: 10px;
    margin-bottom: 28px;
  }
  .dot-left i:nth-child(3), .dot-right i:nth-child(1) { width: 8px; height: 8px; }
  .dot-left i:nth-child(2), .dot-right i:nth-child(2) { width: 6px; height: 6px; }
  .dot-left i:nth-child(1), .dot-right i:nth-child(3) { width: 4px; height: 4px; }

  /* 移动端两个卡片并排 */
  .co-logo-wrap {
    gap: 20px;
  }
  .block-title {
    font-size: 18px;
  }
  .logo-card {
    height: 80px;
    max-width: 160px;
  }
  .host-logo-wrap .logo-card {
    max-width: 200px;
  }

  /* 承办方移动端文字调整 */
  .undertake-block {
    margin-top: 30px;
  }
  .undertake-text {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>